module.exports = __webpack_public_path__ + "img/Desktop_Carousel2.8f12d93d.png";